import { Box, Grid, Typography } from '@mui/material';
import React from 'react';
import { Applicant } from '../../../redux-store/types/api-types';
import { styles } from '../../../Styles/styles';
import { SubHeading } from '../../investors/components';
import { KeyValue } from '../../ApplicationDetails/InvestorWithoutPan/contributor';
import {
  checkRelationshipWithPep,
  currencyConversion,
  getIsServiceRequired,
  getRelationshipWithPepLabel,
  IsInvestorWithPAN,
  IsOutBoundFundFlow,
} from '../../../utils/utilityFunctions';
import {
  AOI_BOI_MASTER,
  investorTypeMasters,
  investorTypeOutboundMasters,
  servicesMaster,
} from '../../../utils/constant';
import { formatShortDate } from '../../../utils/date';
import { Gridstyles } from '../../ApplicationDetails';

export default function ContributorDetails({
  applicants = [],
  flowType,
  fundFlowType,
  ifXalt,
}: {
  applicants: Partial<Applicant>[];
  flowType: string;
  fundFlowType: string;
  ifXalt: boolean;
}): JSX.Element {
  //   const dispatch = useDispatch();
  //   const [brokerList, setBrokerList] = useState<BrokerList>();
  //   useEffect(() => {
  //     (async function () {
  //       try {
  //         const response = (await dispatch(getBrokers())) as unknown as BrokerList;
  //         setBrokerList(response as BrokerList);
  //       } catch (e) {
  //         console.error((e as Error).message);
  //       }
  //     })();
  //   }, []);

  return (
    <>
      <Box sx={styles.ApplicationDetailsCommonLayout} mt={5}>
        <Box sx={{ p: 2 }}>
          <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
            <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
              <Typography
                component="h2"
                sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main', m: 0 }}>
                Contributor Details
              </Typography>
            </Grid>
            {applicants.map((applicant) => {
              const isServicesRequired = getIsServiceRequired(applicant);
              return (
                <React.Fragment key={applicant.id}>
                  <Gridstyles>
                    <Grid
                      item
                      container
                      pb={5}
                      rowSpacing={6}
                      columnSpacing={13}
                      direction="row"
                      justifyContent="space-between"
                      alignItems="flex-start">
                      <KeyValue title={'Name Of Entity'} description={applicant.name} />
                      <KeyValue
                        title={'Date of Registration/Incorporation'}
                        description={formatShortDate(applicant.dateOfBirth)}
                        sx={{ overflowWrap: 'anywhere' }}
                      />
                      <KeyValue
                        title={'Place of Registration/Incorporation'}
                        description={applicant.cityOfIncorporation}
                        sx={{ overflowWrap: 'anywhere' }}
                      />
                      {IsOutBoundFundFlow(fundFlowType) && (
                        <KeyValue
                          title={'Country of Incorporation'}
                          description={applicant.countryOfIncorporation}
                          sx={{ overflowWrap: 'anywhere' }}
                        />
                      )}

                      {applicant.maskedCkycNo ? (
                        <KeyValue
                          title={'CKYC No./CKYC Acknowledge No./KIN No'}
                          description={
                            applicant.maskedCkycNo
                              ? IsOutBoundFundFlow(fundFlowType)
                                ? applicant.maskedCkycNo.length == 4
                                  ? 'XXXXXXXXXX' + applicant.maskedCkycNo
                                  : 'XXXXXXXXXX' + applicant.maskedCkycNo.substring(10, 14)
                                : applicant.maskedCkycNo
                              : 'N/A'
                          }
                        />
                      ) : (
                        <KeyValue
                          title={'CKYC No./CKYC Acknowledge No./KIN No'}
                          description={
                            applicant.ckycNo
                              ? IsOutBoundFundFlow(fundFlowType)
                                ? applicant.ckycNo.length == 4
                                  ? 'XXXXXXXXXX' + applicant.ckycNo
                                  : 'XXXXXXXXXX' + applicant.ckycNo.substring(10, 14)
                                : applicant.ckycNo
                              : 'N/A'
                          }
                        />
                      )}

                      <KeyValue
                        title={'Law Under Which Formed/Incorporated'}
                        description={applicant.lawType}
                      />

                      {/* <KeyValue
                        title={'CVL KRA Verified'}
                        description={applicant.kraVerified}
                        descriptionSx={{
                          textTransform: 'capitalize',
                        }}
                      /> */}
                      <KeyValue
                        title={`AML Verified`}
                        description={applicant.amlCheck ? 'Yes' : 'No'}
                      />
                      {applicant.investorType && (
                        <KeyValue
                          title={'Investor Type'}
                          description={
                            IsOutBoundFundFlow(fundFlowType)
                              ? investorTypeOutboundMasters[applicant.investorType]
                              : investorTypeMasters[applicant.investorType]
                          }
                        />
                      )}
                      {/* {ifXalt &&
                        investorTypeMasters[applicant?.investorType || ''] ===
                          investorTypeMasters.boi_or_aop && (
                          <KeyValue
                            title={'AOP or BOI'}
                            description={AOI_BOI_MASTER[applicant?.boiOrAop || '']}
                          />
                        )} */}
                      <KeyValue
                        title={'Corporate Identification number (if applicable)'}
                        description={applicant.corporateIdentificationNo}
                      />
                      <KeyValue title={'PAN'} description={applicant.panNo} />
                      {applicant.kraMobileNumber && (
                        <KeyValue
                          title={'KRA Mobile Number'}
                          description={applicant.kraMobileNumber}
                        />
                      )}
                      {applicant.kraEmailId && (
                        <KeyValue title={'KRA Email Id'} description={applicant.kraEmailId} />
                      )}
                    </Grid>
                  </Gridstyles>
                  <SubHeading
                    sx={{
                      color: 'common.black',
                      letterSpacing: 0.5 + 'px',
                      padding: { xs: '10px 10px', sm: '10px 30px' },
                    }}>
                    {'Other Details'}
                  </SubHeading>
                  <Gridstyles>
                    <Grid
                      item
                      container
                      pb={5}
                      rowSpacing={6}
                      columnSpacing={21}
                      direction="row"
                      justifyContent="space-between"
                      alignItems="flex-start">
                      <KeyValue
                        title={'Gross Annual Income in USD'}
                        description={applicant.grossAnnualIncome}
                      />
                      <KeyValue
                        title={'Net Worth'}
                        description={applicant.netWorth}
                        amount={currencyConversion(applicant.netWorth, 'usd')}
                      />
                      {IsOutBoundFundFlow(fundFlowType) && (
                        <KeyValue
                          title={'Net Worth Date'}
                          description={formatShortDate(applicant.netWorthDate)}
                        />
                      )}
                      <KeyValue
                        title={'Politically Exposed Person (PEP) Status'}
                        description={applicant.politicallyExposedPersonStatus}
                      />
                      {checkRelationshipWithPep(applicant.politicallyExposedPersonStatus || '') && (
                        <KeyValue
                          title={`${getRelationshipWithPepLabel(
                            applicant.politicallyExposedPersonStatus || ''
                          )}`}
                          description={applicant.relationshipWithPep}
                        />
                      )}
                      {IsOutBoundFundFlow(fundFlowType) && (
                        <KeyValue
                          title="Non-Individual investors involved/providing any of the mentioned services:"
                          description={isServicesRequired
                            ?.map((key) => servicesMaster[key])
                            .join(', ')}
                        />
                      )}
                      {/* <KeyValue
                        title={'Demat Account Details (for allotment of units)'}
                        description={DLCLMasters[applicant.dlclId || '']}
                      />
                      {getdpIdField(applicant.dlclId || '') && (
                        <KeyValue
                          title={isCDSL(applicant.dlclId || '') ? 'DPCL ID' : 'DP ID'}
                          description={applicant.dpId}
                        />
                      )}
                      {getclIdField(applicant.dlclId || '') && (
                        <KeyValue title={'CL ID'} description={applicant.clId} />
                      )}
                      {getdpIdField(applicant.dlclId || '') && (
                        <KeyValue
                          title={'Name of Broker/Depository Participant (DP)'}
                          description={
                            nameOfBrokerExists(
                              brokerList?.broker_list as Broker[],
                              applicant.nameOfBroker || ''
                            )
                              ? brokerList?.broker_list.find(
                                  (broker) => broker.key === applicant.nameOfBroker
                                )?.value
                              : applicant.nameOfBroker
                          }
                        />
                      )} */}
                    </Grid>
                  </Gridstyles>
                </React.Fragment>
              );
            })}
          </Grid>
        </Box>
      </Box>
    </>
  );
}
